import React, { Component } from 'react';
import './App.css';
import Control from "./components/Control";
import Sidebar from "./components/Sidebar";

import placeholder from "../src/assets/icons/placeholder.png";
import arrow from "../src/assets/icons/arrow.png";


let flag = 0, a=0, b=0, c=0, d=0, e=0;
class App extends Component {
  state = {
    showControl: 'Control-container',
    shw: true,
    arrowFlip: 'arrowflip'
  }

  showy = () => {
    if(this.state.shw){
      this.setState({ showControl: 'Control-hide', shw: false, arrowFlip: 'arrow' });
    }else {
      this.setState({ showControl: 'Control-container', shw: true, arrowFlip: 'arrowflip' });
    }
  }

  muteClicked = () => {
    if (flag===0) {
      if(document.getElementById("kiuasnan")){
        document.getElementById("kiuasnan").click();
        a=1;
      }

      if(document.getElementById("kaljanan")){
        document.getElementById("kaljanan").click();
        b=1;
      }

      if(document.getElementById("vastanan")){
        document.getElementById("vastanan").click();
        c=1;
      }

      if(document.getElementById("löylynan")){
        document.getElementById("löylynan").click();
        d=1;
      }

      if(document.getElementById("lintunan")){
        document.getElementById("lintunan").click();
        e=1;
      }

      flag=1;
    }
    else {
      if (document.getElementById("kiuasnan") || document.getElementById("kaljanan") || document.getElementById("vastanan") || document.getElementById("löylynan") || document.getElementById("lintunan") ) { flag=0; return; }
      if(a===1){
        document.getElementById("kiuassnd").click();
      }
      if(b===1){
        document.getElementById("kaljasnd").click();
      }
      if(c===1){
        document.getElementById("vastasnd").click();
      }
      if(d===1){
        document.getElementById("löylysnd").click();
      }
      if(e===1){
        document.getElementById("lintusnd").click();
      }
      
      a=0;b=0;c=0;d=0;e=0;
      flag=0;
    }
  }

  render() {
    return (
      <div className="App bg">
        {/*<header className="App-header">
          <p>
            Sauna
          </p>
        </header>
        <Sidebar />
        <img src={placeholder} onClick={this.muteClicked} alt="mute" id="mutebutton"></img>
        */}
        <div id="header">
          {/*<h1>Aarnin sauna alpha 0.000002</h1>
          <p>Powered by Arvid Nordqvist</p>*/}
        </div>
        <div id="bottom">
          <img className={this.state.arrowFlip} onClick={this.showy} src={arrow} alt="nuoli" />
          <Control id={this.state.showControl} />
        </div>
      </div>
    );
  }
}

export default App;
